module.exports = __webpack_public_path__ + "static/img/Google-Play.41d165f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Google-Play.png
// module id = CcSw
// module chunks = 1